import script from "./ConsentView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsentView.vue?vue&type=script&setup=true&lang=js"

import "./ConsentView.vue?vue&type=style&index=0&id=49ba3d13&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49ba3d13"]])

export default __exports__